//set up as obj
const scrollButton = document.querySelector(".js-scroll-btn");

if(scrollButton) {
    const scrollTarget = document.querySelector(".js-scroll-target");

    function scrollToTarget(el, target, offset) {
        el.addEventListener("click", (e) => {
            e.preventDefault()
            gsap.to(window, {
                duration: 0.6,
                ease: "power4.easeInOut",
                scrollTo: { y: target, offsetY: offset }
            })
        })
    }

    scrollButton.addEventListener('click', scrollToTarget(scrollButton, scrollTarget, 200));
}
